import { gql } from '@apollo/client';

export const UPDATE_AVATAR_IMAGE = gql`
  mutation UpdateAvatarImage($attachment: AttachmentInputType!) {
    updateAvatarImage(input: { attachment: $attachment }) {
      user {
        id
        avatarImageUrl
      }
      errors
    }
  }
`;
